"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onPreferredLocalesChange = exports.setPreferredLocales = void 0;
exports.setServiceInfoURL = setServiceInfoURL;
exports.getServiceInfoURL = getServiceInfoURL;
const localizeText_ts_1 = require("./localizeText.js");
Object.defineProperty(exports, "setPreferredLocales", { enumerable: true, get: function () { return localizeText_ts_1.setPreferredLocales; } });
Object.defineProperty(exports, "onPreferredLocalesChange", { enumerable: true, get: function () { return localizeText_ts_1.onPreferredLocalesChange; } });
// Production HDS registry. Apps targeting another platform (demo, local
// backloop) must call setServiceInfoURL() before any HDSService/HDSModel use.
let serviceInfoUrl = 'https://reg.api.datasafe.dev/service/info';
/**
 * Set default service info URL
 */
function setServiceInfoURL(url) {
    serviceInfoUrl = url;
}
/**
 * Get default service info URL
 */
function getServiceInfoURL() {
    return serviceInfoUrl;
}
